import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { FinancialInstitutionRepository } from '../../../domain/repository';
import { FinancialInstitutionEntity } from '../../../domain/entities/financial-institution-entity';
import fixtures from './fixtures.json';

@Injectable()
export default class FinancialInstitutionDummyRepository implements FinancialInstitutionRepository {
  findAll(): Promise<Array<FinancialInstitutionEntity>> {
    return Promise.resolve(fixtures);
  }
}
